import React from 'react';
import { Button } from '@gravity-ui/uikit';
import isFunction from 'lodash/isFunction';
import { useGenerateRandomValue } from '../../../core/components/Form/hooks';
import i18n from '../../i18n';
import { block } from '../../utils';
import './GenerateRandomValueButton.css';
const b = block('generate-random-value-button');
export const GenerateRandomValueButton = ({ spec, onChange, }) => {
    const generateRandomValue = useGenerateRandomValue();
    if (isFunction(generateRandomValue) && spec.viewSpec.generateRandomValueButton) {
        return (React.createElement(Button, { onClick: () => onChange(generateRandomValue(spec)), className: b() }, i18n('button-generate')));
    }
    return null;
};
